export interface ShareParticipantDTO {
    organizationName: string;
    active: boolean;
}
